export const communicationMenu = [
  {
    name: "estandard",
    label: "menu.communication.estandard",
  },
  {
    name: "custom",
    label: "menu.communication.custom",
  },
];
